import { FormLabel, Grid, TextField } from "@mui/material";
import { Modal } from "../../../components/common/Modal/Modal";
import { ModalHeader } from "../../../components/common/Modal/ModalHeader";
import { ModalBody } from "../../../components/common/Modal/ModalBody";
import { ModalFooter } from "../../../components/common/Modal/ModalFooter";
import { Formik } from "formik";
import { useEffect, useState } from "react";
import { useCourseStore } from "../../../hooks/useCourseStore";
import { Theme } from "../../../types/slices/coursesType";

export const CreateEditThemeWebModal: React.FC<any> = (): JSX.Element | any => {
  const {
    editThemeWeb,
    openModal,
    setOpenModal,
    isEdit,
    selectedModule,
    createThemeWebStore,
    editThemeWebStore,
    getThemeWebByModule,
  } = useCourseStore();

  const [data, setData] = useState<Theme>({
    name: "",
    idmodule: 0,
  });

  const validateForm = (values) => {
    let errors: any = {};
    if (!values.name) errors.name = "Nombre es requerido";
    if (values.name && values.name.length > 100)
      errors.name = "El número máximo de caracteres es 100";

    return errors;
  };

  const onSubmit = async (values) => {
    const method = isEdit
      ? editThemeWebStore(editThemeWeb?.id || 0, values)
      : createThemeWebStore({ ...values, idmodule: selectedModule.id });
    const response = await method;
    if (response === true) {
      getThemeWebByModule(selectedModule.id);
      setData({
        name: "",
        idmodule: 0,
      });
      setOpenModal(false);
    }
  };

  useEffect(() => {
    if (isEdit) {
      setData(editThemeWeb);
    } else {
      setData({
        name: "",
        idmodule: 0,
      });
    }
  }, [isEdit, editThemeWeb]);

  return (
    <>
      <Modal
        open={openModal}
        handleClose={() => setOpenModal(false)}
        disableEscapeKeyDown
        disableBackdropClick
        size="sm"
      >
        <ModalHeader
          text={isEdit ? "Editar Tema" : "Crear Tema"}
          className="positionElements"
          onCancel={() => setOpenModal(false)}
          // clearState={clearEditStudent}
        ></ModalHeader>

        <Formik
          initialValues={data}
          enableReinitialize
          validate={(values) => validateForm(values)}
          onSubmit={onSubmit}
        >
          {({
            values,
            errors,
            touched,
            handleSubmit,
            handleChange,
            setFieldValue,
          }) => {
            return (
              <>
                <ModalBody>
                  <form onSubmit={handleSubmit}>
                    <Grid container>
                      <Grid item container xs={12} spacing={2} sx={{ mt: 2 }}>
                        <Grid item xs={12}>
                          <FormLabel>Nombre:</FormLabel>
                          <TextField
                            id="name"
                            type="text"
                            name="name"
                            fullWidth
                            size="small"
                            value={values.name}
                            onChange={handleChange}
                            error={errors.name && touched.name ? true : false}
                            helperText={
                              errors.name && touched.name ? errors.name : ""
                            }
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </form>
                </ModalBody>
                <ModalFooter
                  confirmText={isEdit ? "Actualizar" : "Registrar"}
                  onConfirm={handleSubmit}
                  cancelText={"Cancelar"}
                  onCancel={() => {
                    setOpenModal(false);
                  }}
                  className="modal-confirm-footer"
                />
              </>
            );
          }}
        </Formik>
      </Modal>
    </>
  );
};
